import { Relation, Translations, UUID } from '@/types/types';
import { ApiQueryKey } from '@/configs/apiQueryKey';
import { AttributeValue } from './AttributeValueApi';
import { Component } from './ComponentApi';
import { Article } from './ArticleApi';
import EntityApi, { BaseEntity } from './EntityApi';

export enum QuantityConfigType {
	PROJECT = 'PROJECT',
	ROLLER_BOX_SEGMENT = 'ROLLER_BOX_SEGMENT',
	MOSQUITO_NET_SEGMENT = 'MOSQUITO_NET_SEGMENT',
}

export enum QuantityConfigCondition {
	AE_TO_AE = 'AE_TO_AE',
	AE_TO_AC = 'AE_TO_AC',
	AE_TO_AC_WIDE = 'AE_TO_AC_WIDE',
	AC_THIN_TO_AC_THIN = 'AC_THIN_TO_AC_THIN',
	AC_THIN_TO_AC_WIDE = 'AC_THIN_TO_AC_WIDE',
	AC_WIDE_TO_AC_WIDE = 'AC_WIDE_TO_AC_WIDE',
	AC_TO_MOSQUITO_NET_EDGE = 'AC_TO_MOSQUITO_NET_EDGE',
	AE_TO_MOSQUITO_NET_EDGE = 'AE_TO_MOSQUITO_NET_EDGE',
	AC_THIN_TO_MOSQUITO_NET_EDGE = 'AC_THIN_TO_MOSQUITO_NET_EDGE',
	AC_WIDE_TO_MOSQUITO_NET_EDGE = 'AC_WIDE_TO_MOSQUITO_NET_EDGE',
	MOSQUITO_NET_EDGE_TO_MOSQUITO_NET_EDGE = 'MOSQUITO_NET_EDGE_TO_MOSQUITO_NET_EDGE',
	ROLLER_BOX_HEIGHT = 'ROLLER_BOX_HEIGHT',
}

export enum QuantityFormulaVariable {
	PW = '$pw',
	PH = '$ph',
	SSW = '$ssw',
	SSH = '$ssh',
	SSWH = '$sswh',

	RW = '$rw',
	RH = '$rh',
	RD = '$rd',

	LPW = '$lpw',
	LPSZ = '$lpsz',
	LPSM_L = '$lpsmL',
	LPSM_P = '$lpsmP',

	$llba = '$llba',
}

export interface QuantityConfig {
	type: QuantityConfigType;
	condition: QuantityConfigCondition | null;
	conditionValue?: string | number;
	formula: string;
}

export interface ComponentVariationArticle extends BaseEntity {
	article?: Article;
	articleId: UUID;
	componentVariation?: ComponentVariation;
	componentVariationId: UUID;
	quantityConfigs: QuantityConfig[];
}

export interface ComponentVariation extends BaseEntity {
	name: string;
	component: Component;
	attributeValues: AttributeValue[];
	componentVariationArticles: ComponentVariationArticle[];
	relations: Relation[];
	translations: Translations<{
		name: string;
	}>;
}

class ComponentVariationApi extends EntityApi<ComponentVariation> {
	constructor() {
		super(ApiQueryKey.componentVariations);
	}
}

export default new ComponentVariationApi();
